import InfoCountMixin from '~/mixins/InfoCountMixin'
import InfoCounter from '@theme/components/atom/InfoCounter'

export default {
  components: {
    InfoCounter,
  },
  mixins: [InfoCountMixin],
}
